<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
  111







  </div>


</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
	  volvalue:[],
	  voldata:[],
      volumeAdjust: {
        ip: "",
        port: "",
        seed: "",
        vol1: 0,
        vol2: 0,
		vol3: 0,
		vol4: 0
      },
      warningSet: {
        flag: true,
        seedList1: {
          data: [],
          value: []
        },
        seedList2: {
          data: [],
          value: []
        },
        file1: "",
        file2: "",
        portwr: "",
        portct: "",
        seed: "",
        ip: ""
      },
      loading: false,
      options: [],
      nodeid: "",
      isroot: false,
      tableData: [],
	  dialogVisible_adddevice6:false,
	  dialogVisible_adddevice4:false,
      tableDatafilelist: [],
      dialogVisible_adddevice : false,
      dialogVisible_adddevice2: false,
      dialogVisible_adddevice3: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false
    };
  },
  created() {
      //  this.reflash_devlist();
      //  this.get_file_list();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {

    putMode() {
      var a = document.getElementById("transfer1");
      var b = document.getElementById("transfer2");
      if (this.warningSet.flag) {
        setTimeout(() => {
          this.warningSet.flag = false;
          a.style.transform = "rotateY(0deg)";
        }, 500);
        a.style.transition = "all 0.5s linear";
        a.style.transform = "rotateY(345deg)";
      } else {
        setTimeout(() => {
          this.warningSet.flag = true;
          b.style.transform = "rotateY(0deg)";
        }, 500);
        b.style.transition = "all 0.5s linear";
        b.style.transform = "rotateY(345deg)";
      }
    },
	revols(){
		this.dialogVisible_adddevice4= true;
	},
    goSetWarning( index , rows ) {
      this.warningSet.ip = rows[index].nodeip;
      this.warningSet.portct = rows[index].nodeport3;
      this.warningSet.seed = rows[index].seed;
      this.dialogVisible_adddevice3 = true;
    },
	goSetWarningauto( index , rows ) {
	  this.warningSet.ip = rows[index].nodeip;
	  this.warningSet.portct = rows[index].nodeport3;
	  this.warningSet.seed = rows[index].seed;
	  this.dialogVisible_adddevice6 = true;
	},
	setWarningcancel() {
		  console.log(this.warningSet);
		  var cmd1 = {
		    cmd: "CANCEL",
		    snlist: ["1","2"],
		    filelist: ["http://xxx.xxx.mp3"]
		  };
		  var cmd2 = {
		    cmd: "CANCEL",
		    snlist: ["1","2"],
		    filelist: ["http://xxx.xxx.mp3"]
		  };

		  let data = new FormData();
		  data.append("username", sessionStorage.getItem("username"));
		  data.append("passwd", sessionStorage.getItem("passwd"));
		  data.append("user_id", sessionStorage.getItem("id"));
		  data.append("enable", 0);
		  data.append("portwr", 0);
		  data.append("portct", this.warningSet.portct);
		  data.append("seed", this.warningSet.seed);
		  data.append("ip", this.warningSet.ip);
		  data.append("id", -2);
		  data.append("cmd1", JSON.stringify(cmd1));
		  data.append("cmd2", JSON.stringify(cmd2));
		  axios
		    .post("/warningsetauto.php", data)
		    .then(
		      function(res) {
		        if (res.data.res) {
		          console.log(res.data);
		          this.$notify.success({
		            title: "Info",
		            message: "报警注销成功",
		            showClose: false
		          });
		        } else {
		          this.$notify.success({
		            title: "Info",
		            message: "报警注销出现异常",
		            showClose: false
		          });
		        }
		      }.bind(this)
		    )
		    .catch(function(res) {
		      console.log(res);
		    });
		  this.dialogVisible_adddevice3 = false;
		},
		setWarningauto() {
		  console.log(this.warningSet);
		  let url_bihe ="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
		  let url_duankai="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3"
		  let data = new FormData();
		  data.append("username", sessionStorage.getItem("username"));
		  data.append("passwd", sessionStorage.getItem("passwd"));
		  data.append("user_id", sessionStorage.getItem("id"));
		  data.append("enable", 0);
		  data.append("portct", this.warningSet.portct);
		  data.append("seed", this.warningSet.seed);
		  data.append("ip", this.warningSet.ip);
		  data.append( "url_bihe" , url_bihe );
		  data.append( "url_duankai" , url_duankai);
		  axios
		    .post("/warningsetauto.php", data)
		    .then(
		      function(res) {
		        if (res.data.res) {
		          console.log(res.data);
		          this.$notify.success({
		            title: "Info",
		            message: "报警注册成功",
		            showClose: false
		          });
		        } else {
		          this.$notify.success({
		            title: "Info",
		            message: "报警注册出现异常",
		            showClose: false
		          });
		        }
		      }.bind(this)
		    )
		    .catch(function(res) {
		      console.log(res);
		    });
		  this.dialogVisible_adddevice3 = false;
		},
		setWarningcancelauto() {
			  console.log(this.warningSet);
			  let url_bihe ="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
			  let url_duankai="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3"
			  let data = new FormData();
			  data.append("username", sessionStorage.getItem("username"));
			  data.append("passwd", sessionStorage.getItem("passwd"));
			  data.append("user_id", sessionStorage.getItem("id"));
			  data.append("enable", 0);
			  data.append("portct", this.warningSet.portct);
			  data.append("seed", this.warningSet.seed);
			  data.append("ip", this.warningSet.ip);
			  data.append("id", -2);
			  data.append("url_bihe" , url_bihe );
			  data.append("url_duankai" , url_duankai );
			  axios
			    .post("/warningsetauto.php", data)
			    .then(
			      function(res) {
			        if (res.data.res) {
			          console.log(res.data);
			          this.$notify.success({
			            title: "Info",
			            message: "报警注销成功",
			            showClose: false
			          });
			        } else {
			          this.$notify.success({
			            title: "Info",
			            message: "报警注销出现异常",
			            showClose: false
			          });
			        }
			      }.bind(this)
			    )
			    .catch(function(res) {
			      console.log(res);
			    });
			  this.dialogVisible_adddevice3 = false;
			},
    setWarning() {
      console.log(this.warningSet);
      var cmd1 = {
        cmd: "CANCEL",
        snlist: ["1","2"],
        filelist: ["http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3"]
      };
      var cmd2 = {
        cmd: "CANCEL",
        snlist: ["1","2"],
        filelist: ["http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3"]
      };
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("user_id", sessionStorage.getItem("id"));
      data.append("enable", 0);
      data.append("portwr", 0);
      data.append("portct", this.warningSet.portct);
      data.append("seed", this.warningSet.seed);
      data.append("ip", this.warningSet.ip);
      data.append( "cmd1" , JSON.stringify(cmd1) );
      data.append( "cmd2" , JSON.stringify(cmd2) );
      axios
        .post("/warningset.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "报警注册成功",
                showClose: false
              });
            } else {
              this.$notify.success({
                title: "Info",
                message: "报警注册出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice3 = false;
    },

    closePromptTone(index, rows) {
      this.loading = true;
      axios
        .get("/edit_vdebug.php", {
          params: {
            seed: rows[index].seed,
            ip: rows[index].nodeip,
            port: rows[index].nodeport5
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.loading = false;
              this.$notify.success({
                title: "Info",
                message: "关闭成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "关闭失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    goAdjustVolume(index, rows) {
      if (rows[index].vol == -1) {
        this.$message({
          message: "设备未上报",
          type: "warning"
        });
      } else {
        if (parseInt(rows[index].vol) <= 1) {
          this.volumeAdjust.vol1 = 0;
        } else if (parseInt(rows[index].vol) <= 15) {
          this.volumeAdjust.vol1 = 10;
        } else if (parseInt(rows[index].vol) <= 25) {
          this.volumeAdjust.vol1 = 20;
        } else if (parseInt(rows[index].vol) <= 30) {
          this.volumeAdjust.vol1 = 30;
        } else if (parseInt(rows[index].vol) <= 35) {
          this.volumeAdjust.vol1 = 40;
        } else if (parseInt(rows[index].vol) <= 40) {
          this.volumeAdjust.vol1 = 50;
        } else if (parseInt(rows[index].vol) <= 45) {
          this.volumeAdjust.vol1 = 60;
        } else if (parseInt(rows[index].vol) <= 50) {
          this.volumeAdjust.vol1 = 70;
        } else if (parseInt(rows[index].vol) <= 55) {
          this.volumeAdjust.vol1 = 80;
        } else if (parseInt(rows[index].vol) <= 60) {
          this.volumeAdjust.vol1 = 90;
        } else {
          this.volumeAdjust.vol1 = 100;
        }
        this.volumeAdjust.seed = rows[index].seed;
        this.volumeAdjust.ip = rows[index].nodeip;
        this.volumeAdjust.port = rows[index].nodeport5;
        this.dialogVisible_adddevice2 = true;
      }
    },
    adjustVolume() {
      switch (this.volumeAdjust.vol1) {
        case 0:
          this.volumeAdjust.vol2 = 1;
          break;
        case 10:
          this.volumeAdjust.vol2 = 15;
          break;
        case 20:
          this.volumeAdjust.vol2 = 25;
          break;
        case 30:
          this.volumeAdjust.vol2 = 30;
          break;
        case 40:
          this.volumeAdjust.vol2 = 35;
          break;
        case 50:
          this.volumeAdjust.vol2 = 40;
          break;
        case 60:
          this.volumeAdjust.vol2 = 45;
          break;
        case 70:
          this.volumeAdjust.vol2 = 50;
          break;
        case 80:
          this.volumeAdjust.vol2 = 55;
          break;
        case 90:
          this.volumeAdjust.vol2 = 60;
          break;
        case 100:
          this.volumeAdjust.vol2 = 63;
      }
      console.log(this.volumeAdjust);
      axios
        .get("/edit_vol.php", {
          params: {
            seed: this.volumeAdjust.seed,
            ip: this.volumeAdjust.ip,
            port: this.volumeAdjust.port,
            vol: this.volumeAdjust.vol2
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
    },
	adjustVolumes() {
		this.dialogVisible_adddevice4=false;
	  switch (this.volumeAdjust.vol3) {
	    case 0:
	      this.volumeAdjust.vol4 = 1;
	      break;
	    case 10:
	      this.volumeAdjust.vol4 = 15;
	      break;
	    case 20:
	      this.volumeAdjust.vol4 = 25;
	      break;
	    case 30:
	      this.volumeAdjust.vol4 = 30;
	      break;
	    case 40:
	      this.volumeAdjust.vol4 = 35;
	      break;
	    case 50:
	      this.volumeAdjust.vol4 = 40;
	      break;
	    case 60:
	      this.volumeAdjust.vol4 = 45;
	      break;
	    case 70:
	      this.volumeAdjust.vol4 = 50;
	      break;
	    case 80:
	      this.volumeAdjust.vol4 = 55;
	      break;
	    case 90:
	      this.volumeAdjust.vol4 = 60;
	      break;
	    case 100:
	      this.volumeAdjust.vol4 = 63;
	  }
	  console.log(this.volumeAdjust);
	  var seedss=[];

	  for(var si =0;si<this.volvalue.length;si++ ){
	  			 seedss.push( this.volvalue[si])
	  }
	  if(seedss.length <1){
	  	return;
	  }
	  let seedsstr = seedss.join("|");

	  let datadf = new FormData();
	  datadf.append("username", sessionStorage.getItem("username"));
	  datadf.append("passwd", sessionStorage.getItem("passwd"));
 	  datadf.append("seed", seedsstr);
	  datadf.append("vol", this.volumeAdjust.vol4);
	  axios
	    .post("/edit_vols.php", datadf).then(
	      function(res) {
	        if (res.data.res) {
	          console.log(res.data);
	          this.$notify.success({
	            title: "Info",
	            message: "修改成功",
	            showClose: false
	          });

	          this.reflash_devlist();
	        } else {
	          console.log(res.data);
	          this.$notify.success({
	            title: "Info",
	            message: "修改失败",
	            showClose: false
	          });
	        }
	      }.bind(this)
	    )
	    .catch(function(res) {
	      console.log(res);
	    });
	  this.dialogVisible_adddevice2 = false;
	},
    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    open5() {
      this.$alert(this.save_backdata, "配置详情", {
        dangerouslyUseHTMLString: false
      });
    },
    handleClose_save_back() {},
    func_addone_device() {
      this.dialogVisible_adddevice = false;
      if (this.name_adddevice.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "设备名字不能为空",
          showClose: true
        });
        return;
      }
      if (this.nodeid == "") {
        this.$notify.success({
          title: "Info",
          message: "您还没有选者设备节点",
          showClose: true
        });
        return;
      }
      if (
        this.seed_adddevice.trim() == "" ||
        this.seed_adddevice.trim().length != 32
      ) {
        this.$notify.success({
          title: "Info",
          message: "设备序列号 seed 不正确",
          showClose: true
        });
        return;
      }
      // 		if(this.sqr_adddevice.trim() == "" ||  this.sqr_adddevice.trim().length != 32 ){
      // 					this.$notify.success({
      // 					  title: 'Info',
      // 					  message: '设备序公钥 sqr 不正确',
      // 					  showClose: true
      // 					});
      // 					return;
      // 		}
      /*
		options:[],
		nodeid:"",
		tableData: [],
		dialogVisible_adddevice: false,
		name_adddevice:"",
		seed_adddevice:"",
		seed_ofnode:"",
		tag1:"",
		tag2:"",
		type:"",
		device_status:"",
		sqr_adddevice:"",
		save_backdata:"",
		dialogVisible_save_back: false,
		dialogVisible_save_back_detail:false
		*/
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeid", this.nodeid);
      data.append("type", this.type);
      data.append("seed", this.seed_adddevice);
      data.append("device_status", this.device_status);
      data.append("device_name", this.name_adddevice);
      data.append("tag1", this.tag1);
      data.append("tag2", this.tag2);
      axios
        .post("/add_user_devices.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "添加成功",
                showClose: false
              });
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加设备出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    func_adddevic() {
      this.reflashnode();
      this.dialogVisible_adddevice = true;
    },
    func_savedevic() {
      const loading = this.$loading({
        lock: true,
        text: "Processing",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector(".div1")
      });



      axios
        .get("/create_config.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.save_backdata = res.data.config;
              this.dialogVisible_save_back = true;
              loading.close();
            } else {
              this.$notify.success({
                title: "Info",
                message: "哪里出现错误了",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    deleteRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      axios
        .get("/del_user_devices.php", {
          params: {
            seed: seed,
            devid: devid,
            username: username,
            passwd: passwd
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res){
          console.log(res);
        });
    },
    renameRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.$prompt("New NAME:", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
        inputErrorMessage: "格式不正确"
      })
        .then(({ value }) => {
          if (value.length >= 30) {
            this.$message({
              type: "info",
              message: "名字输入不合规"
            });
            return;
          }
          let seed = rows[index].seed;
          let newseed = value;
          let devid = rows[index].id;
          let username = sessionStorage.getItem("username");
          let passwd = sessionStorage.getItem("passwd");
          axios
            .get("/redevname.php", {
              params: {
                olseed: seed,
                reseed: newseed,
                devid: devid,
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    resnRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.$prompt("New SEED:", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^(?!\d+$)[\da-zA-Z]+$/,
        inputErrorMessage: "格式不正确"
      })
        .then(({ value }) => {
          if (value.length != 32) {
            this.$message({
              type: "info",
              message: "输入编码不正确 请认真输入"
            });
            return;
          }
          let seed = rows[index].seed;
          let newseed = value;
          let devid = rows[index].id;
          let username = sessionStorage.getItem("username");
          let passwd = sessionStorage.getItem("passwd");
          axios
            .get("/resn.php", {
              params: {
                olseed: seed,
                reseed: newseed,
                devid: devid,
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    handleClose_adddevice3() {
      this.dialogVisible_adddevice3 = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflashnode() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.options = res.data.outlableid;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    reflash_devlist: function() {
      this.warningSet.seedList = [];
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.options = res.data.outlableid;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

      axios
        .get("/get_devicelistweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
			this.voldata=[];
              for (var i = 0; i < res.data.dataJson.length; i++) {



                //res.data.dataJson[i].iswarning =
                //  res.data.dataJson[i].iswarning == 1 ? "报警设备" : "缺省";
                if(res.data.dataJson[i].iswarning == 1){
					res.data.dataJson[i].iswarning ="报警设备";
				}else if(res.data.dataJson[i].iswarning == 2){
					res.data.dataJson[i].iswarning ="报警";
				}else{
					res.data.dataJson[i].iswarning ="缺省";
				}

				switch (res.data.dataJson[i].status) {
                  case "-1":
                    res.data.dataJson[i].status = "不在线";
                    break;
                  case "0":
                    res.data.dataJson[i].status = "不在线";
                    break;
                  case "1":
                    res.data.dataJson[i].status = "在线";
                    break;
                  case "2":
                    res.data.dataJson[i].status = "正在播放";
                }

                switch (res.data.dataJson[i].kind) {
                  case "-1":
                    res.data.dataJson[i].kind = "未知";
                    break;
                  case "0":
                    res.data.dataJson[i].kind = "未知";
                    break;
                  case "1":
                    res.data.dataJson[i].kind = "已开启";
                    break;
                  case "2":
                    res.data.dataJson[i].kind = "关闭";
                    break;
                }
              }
              this.tableData = res.data.dataJson;
              const data = [];
              for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].iswarning == "报警设备") {
                  data.push({
                    key: this.tableData[i].seed,
                    label: this.tableData[i].name
                  });
                };

				this.voldata.push({
					key: this.tableData[i].seed+ "K" +this.tableData[i].nodeip+ "_" +this.tableData[i].nodeport3,
					label: this.tableData[i].name
				});
              }
              this.warningSet.seedList1.data = data;
              this.warningSet.seedList2.data = data;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/gis_Mg.vue